import { FC, Fragment } from "react";
import { ImgRigthLogin } from "../atoms/ImgRigthLogin";
import { LogInForm } from "../molecules/LogInForm";
import { HeaderLogin } from "../molecules/HeaderLogin";
import { Profile } from "@/app/auth/auth";
import { Modal } from "./Modal";
import { Avatar } from "../atoms/Avatar";
import { ProfileListModal } from "./ProfileListModal";
import { setAccessToken } from "@/app/auth/auth.slice";

export type LogInProps = {
  onSubmit: any;
  onSelectProfile: (profile: Profile) => void;
  isLoading: boolean;
  profiles?: Array<Profile>;
  showProfiles: boolean;
  setShowProfiles: () => void;

  usernameLabelText: string;
  usernamePlaceholder: string;
  usernameAutoComplete: boolean;
  passwordPlaceholder: string;
  passwordLabelText: string;
  passwordAutoComplete: boolean;
  termsLabelText: string;
  submitButtonText: string;

  srcLogo: string;
  heading: string;
  subheading: string;
  aHeader: string;
  hrefHeader: string;

  forgotEvent: () => void;
  textForgot: string;
  problemEvent: () => void;
  textProlem: string;

  buttonText: string;
  srcImageRight: string;
};

export const LogIn: FC<LogInProps> = ({
  onSubmit,
  onSelectProfile,
  profiles,
  showProfiles,
  setShowProfiles,
  isLoading,

  srcLogo,
  heading,
  subheading,
  aHeader,
  hrefHeader,

  usernameLabelText,
  usernamePlaceholder,
  usernameAutoComplete,
  passwordLabelText,
  passwordAutoComplete,
  passwordPlaceholder,
  termsLabelText,
  submitButtonText,

  forgotEvent,
  textForgot,
  problemEvent,
  textProlem,
  srcImageRight,
}) => {
  return (
    <Fragment>
      <div className="flex min-h-full flex-1">
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <HeaderLogin
              src={srcLogo}
              h2Text={heading}
              pText={subheading}
              aText={aHeader}
              href={hrefHeader}
            />

            <div className="mt-10">
              <div>
                <LogInForm
                  onSubmit={onSubmit}
                  isLoading={isLoading}
                  usernameLabelText={usernameLabelText}
                  usernameAutoComplete={usernameAutoComplete}
                  usernamePlaceholder={usernamePlaceholder}
                  passwordAutoComplete={passwordAutoComplete}
                  passwordLabelText={passwordLabelText}
                  passwordPlaceholder={passwordPlaceholder}
                  termsLabelText={termsLabelText}
                  submitButtonText={submitButtonText}
                  forgotEvent={forgotEvent}
                  textForgot={textForgot}
                  problemEvent={problemEvent}
                  textProlem={textProlem}
                />
              </div>
              <div className="mt-10"></div>
            </div>
          </div>
        </div>
        <div className="relative flex-1 lg:block">
          <ImgRigthLogin src={srcImageRight} />
        </div>
      </div>

      <ProfileListModal
        visible={showProfiles}
        setVisible={setShowProfiles}
        profiles={profiles ?? []}
        onSelectProfile={onSelectProfile}
      />
    </Fragment>
  );
};
